import React, {  useState , useEffect } from "react";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
function OptionC({ onInputChange, catid, namemain, mainid, defaultValuemain, ref, edit, disabled }) {
    const today = new Date();
    const Datemax = today.getMonth() === 0 ? (today.getFullYear() - 1)+ '-' + 12  : today.getFullYear() + '-' + today.getMonth()
   // const [value, setValue] = useState(sessionStorage.getItem("CurrentMonth") === null || sessionStorage.getItem("CurrentYear") === null ? dayjs(`${today.getFullYear()}-${Number(today.getMonth())+1}-01`) : dayjs(`${sessionStorage.getItem("CurrentYear")}-${sessionStorage.getItem("CurrentMonth")}-01`));

    const [value, setValue] = useState(sessionStorage.getItem("CurrentMonth") === null || sessionStorage.getItem("CurrentYear") === null ? dayjs(`${today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()}-${Number(today.getMonth() === 0 ?12:today.getMonth())}-01`) : dayjs(`${sessionStorage.getItem("CurrentYear")}-${sessionStorage.getItem("CurrentMonth")}-01`));
    /*const [data, setData] = useState([])
    useEffect(() => {
        getdata()
       // //console.log(Datemax)
    }, [])*/

  /*  const getdata = async () => {
        const sendData = {
            CatgId: Number(catid)
        }

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetDetailsValueM', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setData(data)
                })


    };
  */

    useEffect(() => {

        //console.log(value)
    }, [value])
    return (
        <>

         <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={3}>
                                    <MobileDatePicker
                                       disableFuture
                                       disabled={disabled}
                                       label="Select Month and Year"
                                        openTo="year"
                                        views={['year', 'month']}
                                        value={value}
                                        onChange={(newValue) => {
                                            onInputChange(newValue.$M+1,newValue.$y)
                                            setValue(newValue);
                                            sessionStorage.setItem("CurrentMonth", newValue.$M+1)
                                            sessionStorage.setItem("CurrentYear", newValue.$y)
                                            
                                        }}
                                        minDate={dayjs('2022-04-01')}
                                        maxDate={dayjs(Datemax)}
                                        renderInput={(params) => <TextField sx={{ width: 200 }} onKeyDown={(evt) => evt.preventDefault()}  {...params} />}
                                    />
                                </Stack>
            </LocalizationProvider>
        </>
    );
};

export default OptionC;
